<template>
  <v-tooltip bottom>
  <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="t-upload-button"
        icon
        v-on="on"
        v-bind="attrs"
        @click="$emit('upload')"
        >
        <StandardBadge
          v-if="counter == 0"
          color="blue"
          icon="upload"
          style="right: -1px"
          :zoom="1"
          />
        <StandardBadge
          v-else-if="counter > 0"
          :text="counter"
          color="green"
          style="right: -1px"
          :zoom="1"
          />
        <StandardBadge
          v-else
          :icon="value?'check':'upload'"
          :color="value?'green':'blue'"
          style="right: -1px"
          :zoom="1"
          />
          <v-icon>{{icon}}</v-icon>
      </v-btn>
    </template>
    <span>{{tooltip}}</span>
  </v-tooltip>
</template>
<script>
  import StandardBadge from '@/components/StandardComponents/StandardBadge.component.vue';
  export default {
    props: ['icon', 'value', 'counter', 'tooltip'],
    components: {
      StandardBadge,
    },
    data: () => ({
    }),
  }
</script>
<style>
  .t-upload-button {
    position: relative;
  }
</style>
